import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/montbo/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/montbo/';

class MonthlyBonusService {
  getAll() {
    return axios.get(API_URL + `monthlybonus/all`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `monthlybonus/${id}`, { headers: authHeader() });
  }

  create(monthlyBonus) {
    return axios.post(API_URL + `monthlybonus/cre`, {
      memberId: monthlyBonus.memberId,
      month: monthlyBonus.month,
      year: monthlyBonus.year,
      firstName: monthlyBonus.firstName,
      middleName: monthlyBonus.middleName,
      surname: monthlyBonus.surname,
      downlinesNo: monthlyBonus.downlinesNo,
      totalPpv: monthlyBonus.totalPpv,
      totalBonusEarned: monthlyBonus.totalBonusEarned,
      bonusToGive: monthlyBonus.bonusToGive
    }, { headers: authHeader() });
  }

  update(id, monthlyBonus) {
    return axios.put(API_URL + `monthlybonus/${id}/upd`, {
      id: monthlyBonus.id,  
      memberId: monthlyBonus.memberId,
      month: monthlyBonus.month,
      year: monthlyBonus.year,
      firstName: monthlyBonus.firstName,
      middleName: monthlyBonus.middleName,
      surname: monthlyBonus.surname,
      downlinesNo: monthlyBonus.downlinesNo,
      totalPpv: monthlyBonus.totalPpv,
      totalBonusEarned: monthlyBonus.totalBonusEarned,
      bonusToGive: monthlyBonus.bonusToGive
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getMonthlyBonusCount(month, year) {
    return axios.get(API_URL + `monthlybonus/${month}/${year}/count`, { headers: authHeader() });
  }

  getMonthlyBonusByMemberId(memberId) {
    return axios.get(API_URL + `monthlybonus/${memberId}/member`, { headers: authHeader() });
  }

  getMonthlyBonusByMemberIdMonthAndYear(memberId, month, year) {
    return axios.get(API_URL + `monthlybonus/${memberId}/${month}/${year}/membermonthandyear`, { headers: authHeader() });
  }
  
}

export default new MonthlyBonusService();